<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Film</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/Text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/Text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/Text/ch003#copyright-information">Copyright Information</a></li>
<li id="toc-li-4"><a href="#/Text/ch004#acknowledgements">Acknowledgements</a></li>
<li id="toc-li-5"><a href="#/Text/ch005#authors-note">Author’s Note</a></li>
<li id="toc-li-6"><a href="#/Text/ch006#chapter-i-this-is-what-i-see">Chapter I: This Is What I See</a></li>
<li id="toc-li-7"><span href="#/Text/ch007#chapter-ii-through-the-peeping-hole" title="Link target outside of Sample">Chapter II: Through the Peeping Hole</span></li>
<li id="toc-li-8"><span href="#/Text/ch008#chapter-iii-of-my-mind" title="Link target outside of Sample">Chapter III: Of My Mind</span></li>
<li id="toc-li-9"><span href="#/Text/ch009#chapter-iv-when-i-am-silent" title="Link target outside of Sample">Chapter IV: When I Am Silent</span></li>
<li id="toc-li-10"><span href="#/Text/ch010#chapter-v-in-the-long-silence" title="Link target outside of Sample">Chapter V: In the Long Silence</span></li>
<li id="toc-li-11"><span href="#/Text/ch011#chapter-vi-with-no-thought-in-it" title="Link target outside of Sample">Chapter VI: With No Thought in It</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?6ec6b10e